module.exports = "/images/website.svg?2beacdd8486b658a8a87118e226330b1";